"use client";

import React, { ChangeEvent } from "react";
import TextInput from '../../TextInput';
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "./PasswordInput.css";

interface Props {
  errorMessage: string;
  handleBlur: () => void;
  handleFocus: () => void;
  id: string;
  isInvalid: boolean;
  password: string;
  setPassword: React.Dispatch<React.SetStateAction<string>>;
  showPassword: boolean;
  setShowPassword: React.Dispatch<React.SetStateAction<boolean>>;
}

const PasswordInput = (props: Props) => {
  return (
    <>
      <div className={"inputIcon"}>
        <FaEyeSlash
          id={`${props.id}-hide`}
          data-testid={`${props.id}-hide`}
          className={"showHide"}
          onClick={() => {
            props.setShowPassword(!props.showPassword);
          }}
          display={props.showPassword ? "" : "none"}
        />
        <FaEye
          id={`${props.id}-show`}
          data-testid={`${props.id}-show`}
          className={"showHide"}
          onClick={() => {
            props.setShowPassword(!props.showPassword);
          }}
          display={props.showPassword ? "none" : ""}
        />
      </div>
      <TextInput
        inputId={`${props.id}-input`}
        inputValue={props.password}
        isInvalid={props.isInvalid}
        errorMessage={props.errorMessage}
        maxLength={20}
        onChange={(e: ChangeEvent<HTMLInputElement>) =>
          props.setPassword(e.target.value)
        }
        onBlur={props.handleBlur}
        onFocus={props.handleFocus}
        type={props.showPassword ? "text" : "password"}
      />
    </>
  );
};

export default PasswordInput;
